import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import * as XLSX from "xlsx"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
// import { schoolFormValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { DateFormat, getDateTimeString } from "../../helpers/utils"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import { timestampToDate, unixdateconversion } from "../../helpers/utils"
import {
  createOneSchool,
  updateOneSchoolMutation,
  deleteOneSchoolMutation,
  getAllSchools,
} from "./Queries"
import { Helmet } from "react-helmet-async"
import { schoolFormValidation } from "helpers/validations"

class School extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      schoolList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      schoolValues: {},
      columns: [
        {
          name: "School Name",
          selector: row => row.name,
          sortable: true,
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: "Email",
          selector: row => row.email,
          sortable: true,
          cell: row => <span>{row.email ? row.email : ""}</span>,
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllSchoolsList()
  }

  // ageGroupList = []

  getAllSchoolsList = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllSchools, values)
    var quizMastersValue = response.data.getAllSchools.items
    //console.log(quizMastersValue)
    if (quizMastersValue) {
      this.setState({
        isLoading: false,
        schoolList: quizMastersValue,
        totalPage:
          response?.data?.getAllSchools?.pagination?.totalCount /
          response?.data?.getAllSchools?.pagination?.pageLimit,
        totalCount: response?.data?.getAllSchools?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllSchoolsList()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllSchoolsList()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllSchoolsList()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllSchoolsList()
        }
      }
    )
  }

  handleEdit = row => {
    //console.log(row)
    if (row) {
      this.setState({
        schoolValues: {
          id: row.id,
          name: row.name,
          email: row.email,
        },
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }
  HandleRowClicked = row => {
    this.props.history.push("/teachers-list/" + row.id)
  }

  unixconvert = values => {
    return new Date(values).toLocaleString()
  }
  handleSubmit = async values => {
    console.log("values,", values)
    this.state.Label == "Add"
      ? this.addQuizMaster(values)
      : this.editQuizMaster(values)
  }

  addQuizMaster = async values => {
    await MutateRequest(createOneSchool, { data: values })
      .then(res =>
        res.data.createOneSchool.status == "Failure"
          ? ErrorMessage("Email Already Excited")
          : SuccessMessage(Message("school.add"))
      )
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllSchoolsList()
  }

  editQuizMaster = async values => {
    let Data = {
      id: String(values.id),
      data: {
        name: values.name,
        email: values.email,
      },
    }
    await MutateRequest(updateOneSchoolMutation, Data)
      .then(res => SuccessMessage(Message("school.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllSchoolsList()
  }

  addBtnClick = () => {
    this.setState({
      schoolValues: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      schoolValues: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      schoolValues: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteSchool = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteOneSchoolMutation, values)
    var deleteSchoolValue = response?.data
    console.log("deleteSchoolValue", deleteSchoolValue)
    if (deleteSchoolValue.deleteOneSchool.status === "Success") {
      SuccessMessage(Message("school.delete"))
      this.getAllSchoolsList()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      quizMasterDetail: url ? url : "",
    })
  }
  readExcel = file => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        const bufferArray = e.target.result

        const wb = XLSX.read(bufferArray, { type: "buffer" })

        const wsname = wb.SheetNames[0]

        const ws = wb.Sheets[wsname]

        const data = XLSX.utils.sheet_to_json(ws)

        resolve(data)
      }

      fileReader.onerror = error => {
        reject(error)
      }
    })

    promise.then(d => {
      console.log(d)
    })
  }

  render() {
    const initialValues = this.state.schoolValues
    console.log("initialValues", this.state)
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]

    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.school")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"School"}`}
                  buttonText={Message("add.school")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <Row style={{ float: "right" }}></Row>
                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.schoolList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  pageSizeOptions={this.state.pageSizeOptions}
                  rowClicked={this.HandleRowClicked}
                  onSort={this.handleSort}
                  pageLimit={this.state.pageLimit}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.school")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong>{this.state.schoolValues?.name}</strong>{" "}
                      </span>{" "}
                      {Message("quiz")} {" ?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteSchool(this.state.schoolValues.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.school")
                  : Message("update.school")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={schoolFormValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("name.school")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="name"
                                type="text"
                              />
                              {errors.name && (
                                <div className="invalid-feedback d-block">
                                  {errors.name}
                                </div>
                              )}
                              <Label className="requiredField">
                                {Message("name.email")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="email"
                                type="text"
                              />
                              {errors.email && (
                                <div className="invalid-feedback d-block">
                                  {errors.email}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(School)
